import Ajax from '@/lib/ajax'
export default {
  /**
   * 获取热门搜索词
   */
  getrHotSearchKeyWord(id: string) {
    return Ajax.get(`/api/MallConfigManagement/HotSearchKeyWord/${id}`)
  },

  /**
   * 新增或更改热门搜索词
   */
  updateHotSearchKeyWord(value: object, id?: string) {
    let url = '/api/MallConfigManagement/HotSearchKeyWord'
    if(id) {
      url += '/' + id
    }
    let axiosType = id ? 'put' : 'post'
    return Ajax[axiosType](url, value)
  }
}